import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from '../../utils/AuthContext';
import { authApi } from "../../backend_urls/authApi";
import { AuthURL } from "../../routes/auth_routes/AuthURL";
import BaseIcon from "../../components/svg_icons/BaseIcon";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!email.trim()) {
            setError("Please enter your email address.");
            return;
        }

        setLoading(true);
        try {
            await authApi.userForgotPassword({ email });
            setSuccess(true);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.response?.data?.detail ||
                "Unable to process your request."
            );
        } finally { setLoading(false); }
    };

    return (
        <>
            {loading && <LoadingSpinner />}

            <div className="login-container">
                {!success ? (
                    <>
                        <h1>Forgot Password</h1>
                        <p>Forgot your password? Enter your registered email address and we'll send you a secure password reset link.</p>
                        <br />

                        {error && <p className="error-text">{error}</p>}

                        <form onSubmit={handleSubmit}>
                            <div className="login-input-group mt-4">
                                <label className="custom-field one">
                                    <BaseIcon
                                        name="mail"
                                        className="bi bi-envelope-at input-icon"
                                    />

                                    <input
                                        type = "email"
                                        name = "email"
                                        placeholder = " "
                                        value = { email }
                                        onChange = {(e) => {
                                            setEmail(e.target.value);
                                            setError("");
                                        }}
                                    />

                                    <span className="placeholder">
                                        Email ID
                                    </span>
                                </label>

                                <br />

                                <div className="login-button-container">
                                    <button
                                        type="submit"
                                        className="login-button"
                                        disabled={loading}
                                    >
                                        {loading ? "Sending..." : "Send Rest Link"}
                                    </button>

                                    <div>
                                        <Link
                                            to={AuthURL.LOGIN}
                                            className="not-registered-button"
                                        >
                                            Back to Sign In
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </>
                ) : (
                    <>
                        <BaseIcon
                            name="mail"
                            className="forgot-password-success-icon"
                        />

                        <h1>Check Your Email</h1>

                        <p>If an account exists for <strong>{email}</strong>, we've sent a secure password reset link.</p>

                        <p>Open the email and click the link to create a new password. For security, the link will expire after a limited time.</p>

                        <br />

                        <Link to={AuthURL.LOGIN} className="login-button">
                            Back to Sign In
                        </Link>
                    </>
                )}
            </div>
        </>
    );
};

export default ForgotPasswordPage;
